<template>

  <div>

    <devices-add-new
      :is-add-new-device-sidebar-active.sync="isAddNewDeviceSidebarActive"
      :role-options="modelOptions"
      :plan-options="planOptions"
      @refetch-data="refetchData"
    />

    <!-- Filters -->
    <!-- <assets-filters :role-filter.sync="roleFilter" :plan-filter.sync="planFilter" :status-filter.sync="statusFilter"
      :role-options="roleOptions" :plan-options="planOptions" :status-options="isActiveOptions" /> -->

    <!-- Table Container Card -->
    <b-card
      no-body
      class="mb-0"
    >

      <div class="m-2">

        <!-- Table Top -->
        <b-row>

          <!-- Per Page -->
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label>Mostrar</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50"
            />
            <label>items</label>
          </b-col>

          <!-- Search -->
          <b-col
            cols="12"
            md="6"
          >
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input
                v-model="searchQuery"
                class="d-inline-block mr-1"
                placeholder="Pesquisar..."
              />
              <b-button
                variant="primary"
                @click="isAddNewDeviceSidebarActive = true"
              >
                <span class="text-nowrap">+ Dispositivo</span>
              </b-button>
            </div>
          </b-col>
        </b-row>

      </div>

      <b-table
        ref="refDeviceListTable"
        class="position-relative"
        :filter="searchQuery"
        :items="fetchDevices"
        responsive
        :fields="tableColumns"
        
        :sort-by.sync="sortBy"
        show-empty
        empty-text="Nenhum resultado encontrado."
        :sort-desc.sync="isSortDirDesc"
      >

        <!-- Column: Index -->
        <!-- <template #cell(id)="data">
          <div class="text-nowrap">
            <span class="align-text-top text-capitalize">{{ data.raw.id }}</span>
          </div>
        </template> -->

        <!-- Column: Name -->
        <template #cell(name)="data" @click="$router.push('/devices')" >
          <div class="text-nowrap">
            <span class="align-text-top text-capitalize">{{ data.raw.name }}</span>
          </div>
        </template>

        <!-- Column: Model -->
        <template #cell(model)="data">
          <div class="text-nowrap">
            <span class="align-text-top text-capitalize">{{ data.raw.model }}</span>
          </div>
        </template>

        <!-- Column: Firmware -->
        <template #cell(firmware)="data">
          <div class="text-nowrap">
            <span class="align-text-top text-capitalize">{{ data.raw.firmware }}</span>
          </div>
        </template>
        <!-- <template #cell(firmware)="data">
          <div class="text-nowrap">
            <feather-icon
              :icon="resolveUserRoleIcon(data.raw.firmware)"
              size="18"
              class="mr-50"
              :class="`text-${resolveUserRoleVariant(data.raw.firmware)}`"
            />
            <span class="align-text-top text-capitalize">{{ data.raw.firmware }}</span>
          </div>
        </template> -->

        <!-- Column: DeviceKey -->
        <template #cell(deviceKey)="data">
          <div class="text-nowrap">
            <span class="align-text-top text-capitalize">{{ data.raw.deviceKey }}</span>
          </div>
        </template>

        <!-- Column: isActive -->
        <template #cell(isActive)="data">
          <b-badge
            pill
            :variant="`light-${resolveDeviceIsActiveVariant(data.raw.isActive)}`"
            class=""
          >
            {{ data.raw.isActive }}
          </b-badge>
        </template>

        <!-- Column: LastData -->
        <!-- <template #cell(createdAt)="data">
          <div class="text-nowrap">
            <span class="align-text-top text-capitalize">{{ data.raw.createdAt }}</span>
          </div>
        </template> -->

        <!-- Column: Type -->
        <template #cell(brand)="data">
          <div class="text-nowrap">
            <feather-icon
              :icon="resolveDeviceStatusIcon(data.raw.brand)"
              size="18"
              class="mr-50"
              :class="`text-${resolveDeviceModelVariant(data.raw.brand)}`"
            />
            <!-- <span class="align-text-top text-capitalize">{{ data.raw.id }}</span> -->
          </div>
        </template>

        <!-- Column: Actions -->
        <template #cell(actions)="data">
          <b-dropdown
            variant="link"
            no-caret
            :right="$store.state.appConfig.isRTL"
          >

            <template #button-content>
              <feather-icon
                icon="MoreVerticalIcon"
                size="16"
                class="align-middle text-body"
              />
            </template>
            <!-- <b-dropdown-item :to="{ name: 'apps-devices-view', params: { id: data.raw.id } }">
              <feather-icon icon="FileTextIcon" />
              <span class="align-middle ml-50">Detalhes</span>
            </b-dropdown-item> -->

            <b-dropdown-item :to="{ name: 'apps-devices-edit', params: { id: data.raw.id } }">
              <feather-icon icon="EditIcon" />
              <span class="align-middle ml-50">Editar</span>
            </b-dropdown-item>

            <b-dropdown-item 
            @click="deleteDevice(data.raw.id)">
              <feather-icon icon="TrashIcon" />
              <span class="align-middle ml-50">Deletar</span>
            </b-dropdown-item>
          </b-dropdown>
        </template>

      </b-table>

      <div class="mx-2 mb-2">
        <b-row>

          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted">Mostrando {{ dataMeta.from }} até {{ dataMeta.to }} de {{ dataMeta.of }}
              items</span>
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >

            <b-pagination
              v-model="currentPage"
              :total-rows="totalDevices"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>

          </b-col>

        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink,
  BBadge, BDropdown, BDropdownItem, BPagination,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import store from '@/store'
import { ref, onUnmounted } from '@vue/composition-api'
import { avatarText } from '@core/utils/filter'
import DevicesFilters from './DevicesFilters.vue'
import devicesList from './devicesList'
import devicesStoreModule from './devicesStoreModule'
import DevicesAddNew from './DevicesAddNew.vue'

export default {
  components: {
    DevicesFilters,
    DevicesAddNew,

    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,

    vSelect,
  },
  directives: {
    Ripple,
  },
  methods: {
    // confirm texrt
    deleteDevice(id) {
      this.$swal({
        title: 'Tem certeza?',
        text: 'Deseja realmente excluir este dispositivo?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sim, deletar!',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.$swal({
            icon: 'success',
            title: 'Deletado!',
            text: 'O dispositivo foi deletado.',
            customClass: {
              confirmButton: 'btn btn-success',
            },
          })
          this.deviceDelete(id)
        }
      })
    },
  },
  setup({emit}) {
    const DEVICE_APP_STORE_MODULE_NAME = 'app-device'
    // console.log(fetchUsers)

    // Register module
    if (!store.hasModule(DEVICE_APP_STORE_MODULE_NAME)) store.registerModule(DEVICE_APP_STORE_MODULE_NAME, devicesStoreModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(DEVICE_APP_STORE_MODULE_NAME)) store.unregisterModule(DEVICE_APP_STORE_MODULE_NAME)
    })
    
    const deviceDelete = function(id) {
        store.dispatch('app-device/deleteDevice', id)
        .then(() => {
          //emit('refetch-data')//nao consegui fazer assim
          refDeviceListTable.value.refresh()
        })
    }

    const isAddNewDeviceSidebarActive = ref(false)

    const modelOptions = [
      { label: 'Admin', value: 'admin' },
      { label: 'Author', value: 'author' },
      { label: 'Editor', value: 'editor' },
      { label: 'Maintainer', value: 'maintainer' },
      { label: 'Subscriber', value: 'subscriber' },
    ]

    const planOptions = [
      { label: 'Basic', value: 'basic' },
      { label: 'Company', value: 'company' },
      { label: 'Enterprise', value: 'enterprise' },
      { label: 'Team', value: 'team' },
    ]

    const isActiveOptions = [
      { label: 'Pendente', value: 'null' },
      { label: 'Ativo', value: 'true' },
      { label: 'Inativo', value: 'false' },
    ]

    const {
      fetchDevices,
      tableColumns,
      perPage,
      currentPage,
      totalDevices,
      dataMeta,
      perPageOptions,
      searchQuery,
      
      sortBy,
      isSortDirDesc,
      refDeviceListTable,
      refetchData,

      // UI
      resolveDeviceModelVariant,
      resolveDeviceStatusIcon,
      resolveDeviceIsActiveVariant,

      // Extra Filters
      roleFilter,
      planFilter,
      statusFilter,
    } = devicesList()

    return {

      // Sidebar
      isAddNewDeviceSidebarActive,

      fetchDevices,
      deviceDelete,
      tableColumns,
      perPage,
      currentPage,
      totalDevices,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refDeviceListTable,
      refetchData,

      // Filter
      avatarText,

      // UI
      resolveDeviceModelVariant,
      resolveDeviceStatusIcon,
      resolveDeviceIsActiveVariant,

      modelOptions,
      planOptions,
      isActiveOptions,

      // Extra Filters
      roleFilter,
      planFilter,
      statusFilter,
    }
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
